<template>
  <div class="bg-customgray">
    <h1 class="text-3xl uppercase mb-8">
      Fördelar med att testa heron
    </h1>
    <div class="lg:flex w-full mt-4 pb-6">
      <div class="flex-1 px-6 pb-6">
        <img
          class="m-auto"
          src="/images/whistle.svg"
        >
        <h2 class="text-xl uppercase">
          Stärker ditt varumärke
        </h2>
        <p class="text-base tracking-tight">
          Det tar bara 50 millisekunder att bilda ditt första intryck av en
          webbplats. Rätt bild kan göra eller bryta en läsares första intryck.
        </p>
      </div>
      <div class="flex-1 px-6 pb-6">
        <img
          class="m-auto"
          src="/images/binoculars.svg"
        >
        <h2 class="text-xl uppercase">
          Uppmuntrar besökare
        </h2>
        <p class="text-base tracking-tight">
          En väldesignad hero fångar besökarens uppmärksamhet. När du har fångat
          intresse kommer användarna mer sannolikt att bläddra vidare till din
          webbplats för att få veta mer om ditt företag.
        </p>
      </div>
      <div class="flex-1 px-6 pb-6">
        <img
          class="m-auto"
          src="/images/mask.svg"
        >
        <h2 class="text-xl uppercase">
          Första intryck
        </h2>
        <p class="text-base tracking-tight">
          En hero bör innehålla ett meningsfullt meddelande. Detta kommer i
          allmänhet att vara den första biten med innehåll som en användare
          möter på din webbplats och kopplas till ditt företag.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeBlocks',
  props: {},
  methods: {}
}
</script>
<style scoped></style>
